import React, { useState } from 'react';
import Login from './Login';
import Portfolio from './Portfolio';

function App() {
  const [accessGranted, setAccessGranted] = useState(false);

  const handleAccess = (isGranted) => {
    setAccessGranted(isGranted);
  };

  return (
    <div className="App">
      {!accessGranted ? (
        <Login onAccess={handleAccess} />
      ) : (
        <Portfolio />
      )}
    </div>
  );
}

export default App;